import * as React from "react";
import styled from "styled-components";

export interface IPaginationState {
  perPage: number;
  pageIndex: number;
}

export interface IPaginationProps<T> {
  items: T[];
  renderRow: (item: T) => JSX.Element;
}

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1rem 0;
`;

const PaginationButton = styled.button`
  display: flex;
`;

const PaginationDescription = styled.div`
  display: flex;
  margin: 0 2rem;
`;

const PageLengthDescription = styled.div`
  margin-right: 0;
  margin-left: auto;
`;

const PageLengthSelect = styled.select`
  margin: 0 1rem;
`;

export default class Pagination<T> extends React.Component<IPaginationProps<T>, IPaginationState> {
  constructor(props: IPaginationProps<T>) {
    super(props);
    this.state = { pageIndex: 0, perPage: 50 };
  }

  public render() {
    const { pageIndex, perPage } = this.state;
    const classesOnPage = this.props.items.slice(pageIndex * perPage, (pageIndex + 1) * perPage);
    const pageCount = Math.floor(this.props.items.length / perPage) + 1;

    return (
      <>
        <PaginationContainer>
          <PaginationButton disabled={pageIndex === 0} onClick={this.onPreviousPageClick}>
            Previous
          </PaginationButton>
          <PaginationDescription>
            Page {pageIndex + 1} of {pageCount}
          </PaginationDescription>
          <PaginationButton disabled={pageIndex >= pageCount - 1} onClick={this.onNextPageClick}>
            Next
          </PaginationButton>
          <PageLengthDescription>
            {this.props.items.length} item(s). Showing
            <PageLengthSelect value={perPage} onChange={this.onPerPageChange}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </PageLengthSelect>{" "}
            per page.
          </PageLengthDescription>
        </PaginationContainer>
        {classesOnPage.map(this.props.renderRow)}
      </>
    );
  }

  public onPreviousPageClick = () => {
    this.setState({ pageIndex: this.state.pageIndex - 1 });
  };

  public onNextPageClick = () => {
    this.setState({ pageIndex: this.state.pageIndex + 1 });
  };

  public onPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ pageIndex: 0, perPage: parseInt(e.target.value, 10) });
  };
}
